<template>
  <div>
    <div
      v-if="loader"
      class="fixed inset-0 flex items-center justify-center bg-white z-50"
    >
      <img
        src="@/assets/imgs/tuin_loader_v2.gif"
        alt="cargando..."
        class="w-[500px]"
      />
    </div>

    <div
      id="top"
      ref="topElement"
      class="flex flex-col items-center justify-center w-full h-full bg-white mt-2.5 md:mt-6.5"
    >
      <div>
        <FiltersSectionComponent
          v-if="(properties.length > 0) || hasActiveFilters"
          :type-Property="operations"
          :movements="movements"
          :states="states"
          @search="handleSearch"
          @change-filter="handleFilterChange"
        />
        <!--Cards-->
        <div
          v-if="filteredProperties.length > 0"
          class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5  mt-5"
        >
          <div v-for="(property, index) in filteredProperties" :key="index">
            <CardPropertyComponent :property="property" />
          </div>
        </div>
        <!--Paginator-->
        <div
          v-if="filteredProperties.length > 0"
          class="flex w-full md:justify-end justify-center items-center mt-10 mb-10"
        >
          <fwb-pagination
            v-model="currentPage"
            :total-pages="totalPages"
            @click="changePage()"
            previous-label="Anterior"
            next-label="Siguiente"
            :slice-length="1"
          >
            <template #page-button="{ disabled, page, setPage }">
              <button
                class="disabled:cursor-not-allowed ml-0 flex h-8 items-center justify-center border bg-white border-gray-300 px-3 leading-tight text-gray-500 first:rounded-l-lg last:rounded-r-lg"
                :class="{
                  'text-tuin-100': disabled
                }"
                :disabled="disabled"
                @click="setPage(page)"
              >
                {{ page }}
              </button>
            </template>
          </fwb-pagination>
        </div>
      </div>
    </div>
    <div
      v-if="properties.length == 0"
      class="flex flex-col justify-center items-center mt-10"
    >
      <h1>Aún no hay propiedades para compartir</h1>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { FwbPagination,} from "flowbite-vue";
import CardPropertyComponent from "@/components/exchange/components/CardPropertyComponent.vue";
import FiltersSectionComponent from "@/components/exchange/FiltersSectionComponent.vue";

let session = computed(() => store.getters.getUserSession);

let properties = ref([]);
let filteredProperties = ref([]);
let loader = ref(false);

let searchQuery = ref(null);
let filterTypeOperation   = ref('');
let filterTypeProperty    = ref('');
let filterState           = ref('');
let filterCurrency        = ref('');
let filterMinPrice        = ref('');
let filterMaxPrice        = ref('');

let operations  = [];
let movements   = [];
let states      = [];

let currentPage = ref(1);
let totalPages = ref(1);

const topElement = ref(null);
const store = useStore();

const hasActiveFilters = computed(() =>
  !!searchQuery.value || filterTypeProperty.value.length > 0 || !!filterTypeOperation.value || !!filterState.value || !!filterCurrency.value || !!filterMinPrice.value || !!filterMaxPrice.value
);

function normalizeNumberValue(value) {
  if (!value) return '';
  return String(value).replace(/[^0-9]/g, '');
}

async function getList() {
  loader.value = true;
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    let link = `${process.env.VUE_APP_API_BASE_URL}/broker/exchange/${session.value.id}?page=${currentPage.value}`;
    
    if(filterTypeOperation.value != ''){
      link += `&type_operation=${filterTypeOperation.value}`
    }

    if(filterTypeProperty.value.length > 0){
      filterTypeProperty.value.forEach(id => {
        link += `&type_property[]=${id}`
      })
    }

    if(filterState.value != ''){
      link += `&state=${filterState.value}`
    }

    if(filterCurrency.value != ''){
      link += `&currency=${filterCurrency.value}`
    }

    if(filterMinPrice.value != ''){
      link += `&min_price=${normalizeNumberValue(filterMinPrice.value)}`
    }

    if(filterMaxPrice.value != ''){
      link += `&max_price=${normalizeNumberValue(filterMaxPrice.value)}`
    }

    const response = await axios.get(link, options);

    if (response.status == 200) {
      //console.log("Datos recibidos:", response.data);

      properties.value = response.data.resp;
      filteredProperties.value = response.data.resp;
      let pages = response.data.pages;
      currentPage.value = pages.current_page;
      totalPages.value = pages.last_page;
      scrollToTop();
    }

    loader.value = false;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

async function getTypeProperty(){
  try {
    let options = {
      headers: {
        'conttent-type': 'json'
      },
    };

    let link = `${process.env.VUE_APP_API_BASE_URL}/catalogue/type_property`;

    const response = await axios.get(link, options);

    if (response.status == 200) {
      let type_operation = response.data.resp;  
      
      operations = type_operation.map(type => ({
          value: type.id,
          name: type.name
      }));
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

async function getTypeOperation(){
  try {
    let options = {
      headers: {
        'conttent-type': 'json'
      },
    };

    let link = `${process.env.VUE_APP_API_BASE_URL}/catalogue/type_movement_property`;

    const response = await axios.get(link, options);

    if (response.status == 200) {
      let type_properties = response.data.resp;      

      movements = type_properties.map(type => ({
          value: type.id,
          name: type.name
      }));
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

async function getState(){
  try {
    let options = {
      headers: {
        'conttent-type': 'json'
      },
    };

    let link = `${process.env.VUE_APP_API_BASE_URL}/catalogue/states`;

    const response = await axios.get(link, options);

    if (response.status == 200) {
      let estados = response.data.resp;  
      
      states = estados.map(estado => ({
          value: estado.id,
          name: estado.estado
      }));

    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

const scrollToTop = () => {
  if (topElement.value) {
    topElement.value.scrollIntoView({ behavior: "smooth" });
  }
};

async function changePage(){
  //console.log('PAGE',currentPage.value)  
  getList();
}

async function filterProperties(query) {
  const q = (query || '').toLowerCase();
  filteredProperties.value = properties.value.filter((property) => {
    return Object.keys(property).some((key) => {
      if (typeof property[key] === "string") {
        return property[key].toLowerCase().includes(q);
      }
      return false;
    });
  });
}

async function change_filter() {
  currentPage.value = 1;
  getList();
}

function handleSearch(query) {
  searchQuery.value = query;
  filterProperties(query);
}

function handleFilterChange(filters) {
  filterTypeOperation.value = filters.filterTypeOperation;
  filterTypeProperty.value  = filters.filterTypeProperty;
  filterState.value         = filters.filterState;
  filterCurrency.value      = filters.filterCurrency;
  filterMinPrice.value      = filters.filterMinPrice;
  filterMaxPrice.value      = filters.filterMaxPrice;
  change_filter();
}

onMounted(async () => {
  loader.value = true;
  await getTypeProperty();
  await getTypeOperation();
  await getState();
  await getList();
  
  topElement.value = document.getElementById("top");
  loader.value = false;
});
</script>